import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../system/thead";
import {PaginateContext} from "../../context/paginate";


const TABLE_HEAD = ["#", "عنوان", "از تاریخ - تا تاریخ", "از ساعت - تا ساعت", "روز هفته", "وضعیت", "عملیات"];

export function ScheduleGrid({
                               Schedules,
                               setModalOpen,
                               setSelectedRow,
                             }) {

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const week_day = {
    "1": "شنبه",
    "2": "یکشنبه",
    "3": "دوشنبه",
    "4": "سه‌شنبه",
    "5": "چهارشنبه",
    "6": "پنجشنبه",
    "7": "جمعه",
  }

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "عنوان": "title",
    "از تاریخ - تا تاریخ": "client_name",
    "از ساعت - تا ساعت": "field_title",
    "روز هفته": "start_time",
    "وضعیت": "date",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "عنوان": true,
    "از تاریخ - تا تاریخ": true,
    "از ساعت - تا ساعت": true,
    "روز هفته": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {Schedules.map(
          ({id, title, start_date, end_date, start_time, end_time, week_day_id, status}, index) => {
            const isLast = index === Schedules.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(start_date + " - " + end_date)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(start_time + " - " + end_time)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {week_day[week_day_id] + " ها"}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setSelectedRow(Schedules[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}